import { Model, RailsFormat } from "./model"
import { Campus } from "./campus"
import { Day } from "./day"
import { Term } from "./term"
import { Course } from "./course"
import { Topic } from "./topic"
import { Contact } from "./contact"
import { Enrolment } from "./enrolment"
import { PERIODS_BY_CAMPUS } from "@constants/periods";
import { NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS } from "@constants/matrix_classes";

export class MatrixClass extends Model implements RailsFormat {

  private maxPerCampus: number = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS

  constructor(
    public id?: number,
    public campusId?: number,
    public termId?: number,
    public dayId?: number,
    public courseId?: number,
    public topicId?: number,
    public contactId?: number,
    public open: boolean = false,
    public topicTest: boolean = false,
    // NOTE: holidayWeek of 0 means it spans both weeks.
    public holidayWeek: number = 1,
    public period: number = 1,
    public room: number = 1,
    public code: string = null,
    public humanisedCode: string = null,

    public campus: Campus = null,
    public day: Day = null,
    public term: Term = null,
    public course: Course = null,
    public topic: Topic = null,
    public contact: Contact = null,

    public enrolments: Enrolment[] = [],

    public updatedAt: Date = null,
    public createdAt: Date = null,
  ) {
    super()
  }

  static clone(obj: any) {
    const matrixClass: MatrixClass = new this()

    if (obj.id) { matrixClass.id = obj.id }
    if (obj.campusId) { matrixClass.campusId = obj.campusId }
    if (obj.termId) { matrixClass.termId = obj.termId }
    if (obj.dayId) { matrixClass.dayId = obj.dayId }
    if (obj.courseId) { matrixClass.courseId = obj.courseId }
    if (obj.topicId) { matrixClass.topicId = obj.topicId }
    if (obj.contactId) { matrixClass.contactId = obj.contactId }
    if (obj.open) { matrixClass.open = obj.open }
    if (obj.topicTest) { matrixClass.topicTest = obj.topicTest }
    if (obj.holidayWeek !== undefined) { matrixClass.holidayWeek = obj.holidayWeek }
    if (obj.period) { matrixClass.period = obj.period }
    if (obj.room) { matrixClass.room = obj.room }
    if (obj.code) { matrixClass.code = obj.code }
    if (obj.humanisedCode) { matrixClass.humanisedCode = obj.humanisedCode }
    if (obj.updatedAt) { matrixClass.updatedAt = new Date(obj.updatedAt) }
    if (obj.createdAt) { matrixClass.createdAt = new Date(obj.createdAt) }

    if (obj.campus) { matrixClass.campus = Campus.clone(obj.campus) }
    if (obj.day) { matrixClass.day = Day.clone(obj.day) }
    if (obj.term) { matrixClass.term = Term.clone(obj.term) }
    if (obj.course) { matrixClass.course = Course.clone(obj.course) }
    if (obj.topic) { matrixClass.topic = Topic.clone(obj.topic) }
    if (obj.contact) { matrixClass.contact = Contact.clone(obj.contact) }

    if (obj.enrolments && obj.enrolments.length > 0) {
      obj.enrolments.forEach((e: any) => {
        matrixClass.enrolments.push(Enrolment.clone(e))
      })
    }

    return matrixClass
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this)

    if (this.id === 0) { response.id = null }

    return response
  }

  getClassTimeDisplay(): string {
    const allPeriods: any   = PERIODS_BY_CAMPUS

    const campusCode        = this.campus.code
    const dayCode           = this.day.code
    const period            = this.period

    let result              = ""

    if (allPeriods[campusCode]) {
      if (allPeriods[campusCode][dayCode]) {
        result = allPeriods[campusCode][dayCode][period]
      }
    }

    return result
  }

  getEffectiveEnrolmentsCount(): number {
    return this.enrolments.filter((e) => !e.isDisenroled).length
  }

  static getMatrixClassIdsGroupedBySubject(classes: MatrixClass[]): any {
    const result: any = []

    Course.subjectStrings.forEach((s: string) => {
      const ids: number[] = []

      classes.forEach((mc: MatrixClass) => {
        if (mc.course.name.indexOf(s) > -1) { ids.push(mc.id) }
      })

      if (ids.length > 0) { result.push({ name: s, ids }) }
    })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/matrix-class.ts